import { render, staticRenderFns } from "./_productExpired.vue?vue&type=template&id=b697f0cc&scoped=true&"
import script from "./_productExpired.vue?vue&type=script&lang=js&"
export * from "./_productExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b697f0cc",
  null
  
)

export default component.exports